module.exports = __webpack_public_path__ + "static/media/supported-standards.b78cf70b.md";